import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import { Link } from '@/components/links';
import { StackCards } from '@/components/StackCards';
import { Card } from '@/components/StackCards/types';
import IconInstallmentsTerciary from '@/assets/icons/heroIcons/Installments-terciary.svg';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconLightBulb from '@/assets/icons/heroIcons/Light-bulb.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconCoins from '@/assets/icons/heroIcons/Coins.svg';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { AccountsAndRewards } from '@/sections/AccountsAndRewards';
import Hero from '@/sections/Hero';
import Eshops from '@/sections/Eshops';
import MoreInfoSection from '@/sections/MoreInfo';
import { FaqIntro } from '@/sections/FaqIntro';
import { Testimonials as TestimonialsSection } from '@/sections/Testimonials';
import { Button } from '@/components/buttons';
import { InfoBoxes } from '@/components/boxes';
import { SectionHeadline } from '@/components/SectionHeadline';
import { type IntlProps, getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import { mergeClasses } from '@/utils/style';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import { NumericRange } from '@/types/range';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { getTestimonialsBySlug, Testimonial } from '@/api/sanity/testimonials';
import { SeoHeader } from '@/components/SeoHeader';
import { type EshopsList, getAffiliateEshopsList } from '@/api/sanity/affiliateEshopsList';
import { AnimatedSection, AnimatedContent } from '@/components/animation';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import { getSectionAnchorId } from '@/utils/anchors';
interface Props extends IntlProps {
  pageBanner: PageBanner | null;
  eshops: EshopsList;
  testimonials: Testimonial[];
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(props) {
  const $ = _c(123);
  usePageView("pay-in-three");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["payInThree", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    pageBanner,
    eshops,
    testimonials,
    menuPromoBanners
  } = props;
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t1;
  if ($[1] !== t) {
    t1 = Array.from({
      length: 4
    }, (_, index) => {
      const cardIndex = index + 1 as NumericRange<1, 4>;
      return {
        index,
        title: <div className={mergeClasses(cardIndex === 4 && "text-center md:text-left")}>{t(`howItWorks.items.${cardIndex}.title`)}</div>,
        ...(cardIndex < 4 ? {
          description: <Trans t={t} i18nKey={`howItWorks.items.${cardIndex}.text`}><Link to={LINKS().whereToShop} testId="payInThreeWhereToShop" analyticsParam="payInThreeWhereToShop" /><Link to="https://promo.skippay.cz/bank-id/" testId="payInThreeBankId" analyticsParam="payInThreeBankId" /></Trans>
        } : {
          footer: <div className="text-center md:text-left"><Button analyticsParam="payInThreehowItWorksiWantMaxi" testId="payInThreehowItWorksiWantMaxi" variant="primary" size="lg" className="w-full md:w-auto" to={LINKS().whereToShop}>{t(`howItWorks.items.${cardIndex}.text`)}</Button></div>
        }),
        images: {
          desktop: {
            src: `/images/sections/payInThree/cards/${process.env.NEXT_PUBLIC_LANGUAGE}/${cardIndex}.png`,
            alt: t(`howItWorks.items.${cardIndex}.title`)
          },
          mobile: {
            src: `/images/sections/payInThree/cards/${process.env.NEXT_PUBLIC_LANGUAGE}/${cardIndex}${cardIndex === 1 ? "-mobile" : ""}.png`,
            alt: t(`howItWorks.items.${cardIndex}.title`)
          },
          ...(cardIndex < 4 && {
            variant: "appMockup"
          })
        }
      };
    });
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cards = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("seo.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("seo.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      url: `${process.env.NEXT_PUBLIC_BASE_URL}/images/sections/payInThree/og/${process.env.NEXT_PUBLIC_LANGUAGE}/image.png`,
      secure_url: `${process.env.NEXT_PUBLIC_BASE_URL}/images/sections/payInThree/og/${process.env.NEXT_PUBLIC_LANGUAGE}/image.png`,
      type: "image/png",
      width: 1200,
      height: 630
    }, {
      url: `${process.env.NEXT_PUBLIC_BASE_URL}/images/sections/payInThree/og/${process.env.NEXT_PUBLIC_LANGUAGE}/image_square.png`,
      secure_url: `${process.env.NEXT_PUBLIC_BASE_URL}/images/sections/payInThree/og/${process.env.NEXT_PUBLIC_LANGUAGE}/image_square.png`,
      type: "image/png",
      width: 300,
      height: 300
    }];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3) {
    t5 = <SeoHeader title={t2} description={t3} images={t4} />;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = pageBanner ? pageBanner.videoId : "eKt1aAhdOWI";
  let t7;
  if ($[11] !== pageBanner?.title || $[12] !== t) {
    t7 = pageBanner?.title ?? t("banner.title");
    $[11] = pageBanner?.title;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== pageBanner?.text || $[15] !== t) {
    t8 = pageBanner?.text ?? t("banner.text");
    $[14] = pageBanner?.text;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== pageBanner || $[18] !== t) {
    t9 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("banner.cta"),
      label: t("banner.cta"),
      to: LINKS().registration,
      testId: "payInThreeHeroPrimaryCTA",
      analyticsParam: "payInThreeHeroPrimaryCTA",
      variant: "primary"
    }];
    $[17] = pageBanner;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = pageBanner?.image?.url ?? "/images/sections/payInThree/hero/hero.png";
  let t11;
  if ($[20] !== pageBanner?.image?.alt || $[21] !== t) {
    t11 = pageBanner?.image?.alt ?? t("banner.title");
    $[20] = pageBanner?.image?.alt;
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = {
      url: t10,
      alt: t11
    };
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = pageBanner?.variant || "products";
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t14 = <Hero videoId={t6} title={t7} text={t8} buttons={t9} image={t12} variant={t13} />;
    $[26] = t12;
    $[27] = t13;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getSectionAnchorId("advantages");
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("advantages.title");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <SectionHeadline className="mb-10 lg:mb-16" variant="inverted" anchorKey="advantages.title">{t16}</SectionHeadline>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("advantages.items.1.title");
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t) {
    t19 = t("advantages.items.1.text");
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconThird />;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t18 || $[44] !== t19) {
    t21 = {
      title: t18,
      paragraph: t19,
      icon: t20
    };
    $[43] = t18;
    $[44] = t19;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t) {
    t22 = t("advantages.items.2.title");
    $[46] = t;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t) {
    t23 = t("advantages.items.2.text");
    $[48] = t;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <IconInstallmentsTerciary />;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t22 || $[52] !== t23) {
    t25 = {
      title: t22,
      paragraph: t23,
      icon: t24
    };
    $[51] = t22;
    $[52] = t23;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t) {
    t26 = t("advantages.items.3.title");
    $[54] = t;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t) {
    t27 = t("advantages.items.3.text");
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <IconPay />;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t26 || $[60] !== t27) {
    t29 = {
      title: t26,
      paragraph: t27,
      icon: t28
    };
    $[59] = t26;
    $[60] = t27;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t21 || $[63] !== t25 || $[64] !== t29) {
    t30 = <InfoBoxes items={[t21, t25, t29]} variant="inverted" withCharacters={true} />;
    $[62] = t21;
    $[63] = t25;
    $[64] = t29;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = LINKS();
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  const t32 = t31.registration;
  let t33;
  if ($[67] !== t) {
    t33 = t("advantages.cta");
    $[67] = t;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t33) {
    t34 = <Button to={t32} testId="payInThreeRegistration" analyticsParam="payInThreeRegistration" size="lg" variant="primary" align="center" className="mt-12 md:mt-16">{t33}</Button>;
    $[69] = t33;
    $[70] = t34;
  } else {
    t34 = $[70];
  }
  let t35;
  if ($[71] !== t17 || $[72] !== t30 || $[73] !== t34) {
    t35 = <AnimatedContent className="px-4 pb-10 lg:pb-20">{t17}{t30}{t34}</AnimatedContent>;
    $[71] = t17;
    $[72] = t30;
    $[73] = t34;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== t) {
    t36 = t("howItWorks.title");
    $[75] = t;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== t36) {
    t37 = <SectionHeadline className="mb-10 px-4 md:mb-16" variant="inverted" anchorKey="howItWorks.title">{t36}</SectionHeadline>;
    $[77] = t36;
    $[78] = t37;
  } else {
    t37 = $[78];
  }
  let t38;
  if ($[79] !== cards) {
    t38 = <StackCards imagePosition="left" cards={cards} />;
    $[79] = cards;
    $[80] = t38;
  } else {
    t38 = $[80];
  }
  let t39;
  if ($[81] !== t37 || $[82] !== t38) {
    t39 = <AnimatedContent className="px-4 pt-10 lg:pt-20">{t37}{t38}</AnimatedContent>;
    $[81] = t37;
    $[82] = t38;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== t35 || $[85] !== t39) {
    t40 = <AnimatedSection bgColor="bg-blue-900" id={t15}>{t35}{t39}</AnimatedSection>;
    $[84] = t35;
    $[85] = t39;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  let t41;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = getSectionAnchorId("accountsAndRewards");
    $[87] = t41;
  } else {
    t41 = $[87];
  }
  let t42;
  if ($[88] !== eshops) {
    t42 = eshops.length > 0 && <AnimatedContent className="pb-14 lg:pb-20"><Eshops eshops={eshops} /></AnimatedContent>;
    $[88] = eshops;
    $[89] = t42;
  } else {
    t42 = $[89];
  }
  let t43;
  if ($[90] !== isCsLanguage) {
    t43 = isCsLanguage && <AnimatedContent className="relative z-10 py-10 lg:py-20"><AccountsAndRewards /></AnimatedContent>;
    $[90] = isCsLanguage;
    $[91] = t43;
  } else {
    t43 = $[91];
  }
  let t44;
  if ($[92] !== t42 || $[93] !== t43) {
    t44 = <AnimatedSection bgColor="bg-blue-50" className="overflow-hidden" id={t41}>{t42}{t43}</AnimatedSection>;
    $[92] = t42;
    $[93] = t43;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = getSectionAnchorId("moreInfo");
    $[95] = t45;
  } else {
    t45 = $[95];
  }
  let t46;
  if ($[96] !== testimonials) {
    t46 = <AnimatedContent className="relative z-10 pb-10 lg:pb-20"><TestimonialsSection testimonials={testimonials} /></AnimatedContent>;
    $[96] = testimonials;
    $[97] = t46;
  } else {
    t46 = $[97];
  }
  let t47;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = LINKS();
    $[98] = t47;
  } else {
    t47 = $[98];
  }
  let t48;
  if ($[99] !== isHuLanguage) {
    t48 = isHuLanguage ? LINKS().faqCategory("vasarlas-harom-reszletben") : LINKS().faqCategory("nakup-na-tretinu");
    $[99] = isHuLanguage;
    $[100] = t48;
  } else {
    t48 = $[100];
  }
  let t49;
  if ($[101] !== t48) {
    t49 = <Link to={t48} analyticsParam="faqPayInThree" testId="faqPayInThree" />;
    $[101] = t48;
    $[102] = t49;
  } else {
    t49 = $[102];
  }
  let t50;
  if ($[103] !== t || $[104] !== t49) {
    t50 = <AnimatedContent className="relative z-10 py-10 lg:py-20"><FaqIntro link={t47.faq} text={<Trans i18nKey="faq.text" t={t}>{t49}</Trans>} /></AnimatedContent>;
    $[103] = t;
    $[104] = t49;
    $[105] = t50;
  } else {
    t50 = $[105];
  }
  let t51;
  if ($[106] !== isCsLanguage || $[107] !== t) {
    t51 = <AnimatedContent className="relative z-10"><MoreInfoSection buttons={isCsLanguage ? [{
        analyticsParam: "homepageMoreInfoDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "homepageMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "payInThreeMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "payInThreeMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "payInThreeMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "payInThreeMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }, {
        analyticsParam: "payInThreeMoreInfoShopWisely",
        icon: <IconLightBulb className="fillButtonIcon" />,
        testId: "payInThreeMoreInfoShopWisely",
        title: t("core:link.shopWisely"),
        to: LINKS().shopWisely
      }] : [{
        analyticsParam: "payInThreeMorePricing",
        icon: <IconCoins className="fillButtonIcon" />,
        testId: "payInThreeMorePricing",
        title: t("core:products.pricing"),
        to: LINKS().pricing
      }, {
        analyticsParam: "payInThreeMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "payInThreeMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "payInThreeMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "payInThreeMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "payInThreeMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "payInThreeMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></AnimatedContent>;
    $[106] = isCsLanguage;
    $[107] = t;
    $[108] = t51;
  } else {
    t51 = $[108];
  }
  let t52;
  let t53;
  let t54;
  if ($[109] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <div className="bgCircle absolute top-1/4 right-0 translate-x-1/3 rotate-270 md:hidden" />;
    t53 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    t54 = <div className="bgCircle absolute top-0 left-0 -translate-x-1/2 translate-y-1/4 rotate-180" />;
    $[109] = t52;
    $[110] = t53;
    $[111] = t54;
  } else {
    t52 = $[109];
    t53 = $[110];
    t54 = $[111];
  }
  let t55;
  if ($[112] !== t46 || $[113] !== t50 || $[114] !== t51) {
    t55 = <AnimatedSection bgColor="bg-blue-100" className="overflow-hidden pb-0!" id={t45}>{t46}{t50}{t51}{t52}{t53}{t54}</AnimatedSection>;
    $[112] = t46;
    $[113] = t50;
    $[114] = t51;
    $[115] = t55;
  } else {
    t55 = $[115];
  }
  let t56;
  if ($[116] !== menuPromoBanners || $[117] !== t14 || $[118] !== t40 || $[119] !== t44 || $[120] !== t5 || $[121] !== t55) {
    t56 = <Layout menuPromoBanners={menuPromoBanners}>{t5}{t14}{t40}{t44}{t55}</Layout>;
    $[116] = menuPromoBanners;
    $[117] = t14;
    $[118] = t40;
    $[119] = t44;
    $[120] = t5;
    $[121] = t55;
    $[122] = t56;
  } else {
    t56 = $[122];
  }
  return t56;
}
export const getStaticProps = (async ctx => {
  return {
    props: {
      pageBanner: await getPageBannerBySlug('pay-in-three'),
      testimonials: await getTestimonialsBySlug('pay-in-three'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      eshops: await getAffiliateEshopsList('pay-in-three'),
      ...(await getIntlProps(ctx, ['core', 'eshops', 'payInThree', 'homepage', 'testimonials']))
    }
  };
}) satisfies GetStaticProps<Props>;